export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7064cf33cd0163fe85ec51c2d81befc4256a75b6b8&name=pushAdClickData!'